import { createApi } from '@reduxjs/toolkit/query/react'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'
import {
  GetCommissionsParams,
  GetCommissionsResponse,
  MarkAsPaidParams,
  GenerateCommissionPdfParams,
} from './commissions.types'

const baseUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE_API}`

export const commissionsApi = createApi({
  reducerPath: 'commissionsApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  tagTypes: ['Commissions'],
  endpoints: (builder) => ({
    getCommissions: builder.query<GetCommissionsResponse, GetCommissionsParams>({
      query: ({ userId, week, status }) => {
        let url = `oapi/v1/commissions/${userId}`
        const params = new URLSearchParams()
        if (week !== undefined) {
          params.append('week', week.toString())
        }
        if (status) {
          params.append('status', status)
        }
        const queryString = params.toString()
        if (queryString) {
          url += `?${queryString}`
        }
        return { url }
      },
      providesTags: ['Commissions'],
    }),

    getAvailableWeeks: builder.query<number[], { userId: string; status?: string }>({
      query: ({ userId, status }) => {
        let url = `oapi/v1/commissions/${userId}/weeks`
        if (status) {
          url += `?status=${status}`
        }
        return { url }
      },
    }),

    markCommissionsAsPaid: builder.mutation<{ message: string }, MarkAsPaidParams>({
      query: ({ userId, week }) => ({
        url: `oapi/v1/commissions/${userId}/mark-paid?week=${week}`,
        method: 'PUT',
      }),
      invalidatesTags: ['Commissions'],
    }),

    generateCommissionPdf: builder.mutation<Blob, GenerateCommissionPdfParams>({
      query: ({ userId, week, status }) => {
        let url = `oapi/v1/commissions/${userId}/generate-pdf`
        const params = new URLSearchParams()
        if (week !== undefined) {
          params.append('week', week.toString())
        }
        if (status) {
          params.append('status', status)
        }
        const queryString = params.toString()
        if (queryString) {
          url += `?${queryString}`
        }
        return {
          url,
          responseHandler: async (response) => {
            const blob = await response.blob()
            return blob
          },
        }
      },
    }),
  }),
})

export const {
  useGetCommissionsQuery,
  useLazyGetCommissionsQuery,
  useGetAvailableWeeksQuery,
  useMarkCommissionsAsPaidMutation,
  useGenerateCommissionPdfMutation,
} = commissionsApi

